export default __webpack_public_path__ + "static/media/card.b5591fe2.svg";